var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "boss-text" }, [
      _vm._v("\n    [" + _vm._s(_vm.content.parentName) + "]\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "padding-left-1" }, [
      _c("span", {
        staticClass: "pega-break pega-pre-wrap",
        attrs: { id: _vm.targetId, "data-test": "value" },
        domProps: { textContent: _vm._s(_vm.nameValue || "未登録") },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }